import { render, staticRenderFns } from "./HowTo.vue?vue&type=template&id=d5b8e4cc&scoped=true&"
import script from "./HowTo.vue?vue&type=script&lang=js&"
export * from "./HowTo.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/faq.scss?vue&type=style&index=0&id=d5b8e4cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b8e4cc",
  null
  
)

export default component.exports